import { useAppSelector } from "../../../../../redux/store";
import { format } from "date-fns";

import {
  Paper,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Typography,
  Alert,
} from "@mui/material";

import PaperWrapper from "../../../../../components/PaperWrapper";

const flattenData = (data: any) => {
  const result: any = {};

  for (const key in data) {
    if (typeof data[key] === "object") {
      const nestedData = flattenData(data[key]);

      for (const nestedKey in nestedData) {
        result[`${key}.${nestedKey}`] = nestedData[nestedKey];
      }
    } else {
      result[key] = data[key];
    }
  }

  return result;
};

const HistoryTab = () => {
  const { selectedUser } = useAppSelector((state) => state.users) as any;

  return (
    <PaperWrapper>
      <Paper sx={{ p: 2 }} elevation={0}>
        <Stepper activeStep={-1} orientation="vertical">
          {selectedUser?.events?.map((record: any, index: any) => (
            <Step active key={index}>
              <StepLabel
                optional={
                  <Typography variant="caption">
                    {`${record?.type}D`} by{" "}
                    <strong>{record?.eventOwner?.name}</strong>
                  </Typography>
                }
              >
                <Alert
                  icon={false}
                  variant="outlined"
                  severity={
                    record.type === "CREATE"
                      ? "success"
                      : record.type === "DELETE"
                        ? "error"
                        : "info"
                  }
                >
                  {format(new Date(record?.date), "MM/dd/yyyy hh:mm:ss")}
                </Alert>
              </StepLabel>
              <StepContent>
                {Object.entries(flattenData(record?.data)).map(
                  ([key, value]) => {
                    return (
                      <Typography key={key}>
                        <strong>{key}:</strong> {JSON.stringify(value, null, 2)}
                      </Typography>
                    );
                  }
                )}
              </StepContent>
            </Step>
          ))}
        </Stepper>
      </Paper>
    </PaperWrapper>
  );
};

export default HistoryTab;
